import React from 'react';

function DisolveIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="24"
            viewBox="0 0 22 24"
            fill="none"
        >
            <path
                d="M7.44116 1.41178H11.3235C11.6809 1.41178 11.9706 1.72781 11.9706 2.11767V6.35297C11.9706 6.74283 11.6809 7.05886 11.3235 7.05886H7.44116C7.08379 7.05886 6.79409 6.74283 6.79409 6.35297V2.11767C6.79413 1.72781 7.08383 1.41178 7.44116 1.41178ZM17.4706 0H21.3529C21.7103 0 22 0.316031 22 0.705891V4.94119C22 5.33105 21.7103 5.64708 21.3529 5.64708H17.4706C17.1132 5.64708 16.8235 5.33105 16.8235 4.94119V0.705891C16.8235 0.316031 17.1133 0 17.4706 0ZM15.2059 9.52941H19.0882C19.4456 9.52941 19.7353 9.84544 19.7353 10.2353V14.4706C19.7353 14.8605 19.4456 15.1765 19.0882 15.1765H15.2059C14.8485 15.1765 14.5588 14.8605 14.5588 14.4706V10.2353C14.5588 9.84544 14.8485 9.52941 15.2059 9.52941ZM14.2353 18.3529C14.5927 18.3529 14.8824 18.669 14.8824 19.0588V23.2941C14.8824 23.684 14.5927 24 14.2353 24H0.647066C0.289695 24 0 23.684 0 23.2941V8.47059C0 8.08073 0.289695 7.7647 0.647066 7.7647H4.52942C4.88679 7.7647 5.17649 8.08073 5.17649 8.47059V13.0588H9.38236C9.73973 13.0588 10.0294 13.3748 10.0294 13.7647V18.3529H14.2353Z"
                fill="#ED6262"
            />
        </svg>
    );
}

export default DisolveIcon;
